import { render, staticRenderFns } from "./MoVisualLayout.vue?vue&type=template&id=d0a5f20e&"
import script from "./MoVisualLayout.vue?vue&type=script&lang=ts&"
export * from "./MoVisualLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports